import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  EnvironmentProviders,
  Provider,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpTimingInterceptor } from './http-timing.interceptor';
import { NavigationTimingService } from './navigation-timing.service';

/**
 * Registers HTTP + navigation timing. Returns nothing when
 * `environment.perfProfilingEnabled` is false (prod, exp), so those builds pay
 * no runtime cost.
 */
export function provideProfiling(): (Provider | EnvironmentProviders)[] {
  if (!environment.perfProfilingEnabled) {
    return [];
  }

  return [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTimingInterceptor,
      multi: true,
    },
    provideAppInitializer(() => {
      inject(NavigationTimingService);
    }),
  ];
}
